// extracted by mini-css-extract-plugin
export default {"signatureBox":"styles_signatureBox__gIcZh","skipButton":"styles_skipButton__CAqZ1"};